<template>
  <div class="block">
       <div class="row">
                    <div class="input-field">
                        <input v-model="username" id="email" type="email" class="validate">
                        <label for="email" class="active">Email</label>
                    </div>
                    <div class="input-field">
                        <input v-model="password" id="password" type="password">
                        <label for="password" class="active">Password</label>
                    </div>
       </div>
        <div class="row">
          <div class="col s4 offset-s4 ">
          <router-link class="btn waves-effect waves-light right red accent-2" :to="{ name: 'Register' }">Register
          </router-link>
          </div>
          <div class="col s4">
            <button class="btn waves-effect waves-light right" v-on:click="login()">Log in
            </button>
          </div>
        </div>
        <div class="row">
          <p class="center-align"><small>{{ environment }} - {{ appVersion}} <span class="green-text" v-if="apiPing">- connected</span><span class="red-text" v-else>- disconnected</span> </small></p>
        </div>
  </div>
</template>

<script>
import api from '@/api'
import {displayError} from '@/helpers/error'
export default {
  name: 'login',
  data: function () {
    return {
      username: undefined,
      password: undefined,
      environment: process.env.NODE_ENV,
      appVersion: process.env.APP_VERSION,
      apiPing: false
    }
  },
  mounted () {
    api.ping()
      .then(ok => { this.apiPing = ok })
  },
  methods: {
    login: function () {
      // Auth
      api.auth(this.username, this.password).then((me) => {
        api.setCurrentUser(me)
        this.$reloadApp()
      }).catch((e) => displayError(e))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.block {
  padding-top: 10px;
  margin-top: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue